module.exports = "<p>\r\n  creditbureau works!\r\n</p>\r\n"